import { Extension } from "@tiptap/core";

export const ContentEditable = Extension.create({
    name: "ContentEditable",
    addGlobalAttributes() {
        return [
            {
                // This applies to all nodes
                types: [
                    "paragraph",
                    "heading",
                    "blockquote",
                    "listItem",
                    "codeBlock",
                    "image",
                    "table",
                    "tableRow",
                    "tableCell",
                    "tableHeader",
                    "bold",
                ],
                attributes: {
                    editable: {
                        default: true,
                        parseHTML: (element) => {
                            const notEditable =
                                element.getAttribute("data-editable") ===
                                    "false" ||
                                element.getAttribute("contenteditable") ===
                                    "false";
                            return !notEditable;
                        },
                        renderHTML: (attributes) => {
                            if (attributes.editable === false) {
                                return {
                                    contenteditable: "false",
                                    style: "pointer-events: none;",
                                    tabIndex: -1,
                                    onclick: "return false;",
                                };
                            }
                            return {};
                        },
                    },
                },
            },
        ];
    },
});
